export function pickHex(color1, color2, weight) {
    var w1 = weight;
    var w2 = 1 - w1;

    var c1 = hexToRgb(color1);
    var c2 = hexToRgb(color2);

    var rgb = {
        r: Math.round(c1.r * w1 + c2.r * w2),
        g: Math.round(c1.g * w1 + c2.g * w2),
        b: Math.round(c1.b * w1 + c2.b * w2)
    };

    return rgbToHex(rgb);
}

export function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function componentToHex(c) {
    var hex = c.toString(16);

    return hex.length === 1 ? "0" + hex : hex;
}

export function rgbToHex(c) {
    return "#" + componentToHex(c.r) + componentToHex(c.g) + componentToHex(c.b);
}

export function getBodyThemeColors() {
    const bodyStyles = getComputedStyle(document.body);

    return {
        topColor: bodyStyles.getPropertyValue("--top-color").replace(" ", ""),
        bottomColor: bodyStyles.getPropertyValue("--bottom-color").replace(" ", ""),
    };
}

export function getTheme() {
    const hour = (new Date()).getHours()
    const night = hour < 6 || hour > 19;

    return night ? "night" : "day";
}



// WEBPACK FOOTER //
// ./src/util/colors.js